import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { LoadableLogin } from './loadable-components';

/**
 * Renders the routes.
 */
const PublicRoutes = () => (
  <Switch>
    <Route exact path="/login" component={LoadableLogin} />
    <Redirect from="/" to="/login" />
  </Switch>
);

export default PublicRoutes;
